import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AwComponent } from '@aw-hospital/aw-components-lib/aw-parent';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
class AwSpinnerComponent extends AwComponent {
    constructor() {
        super(...arguments);
        this.spinnerSize = 'small';
        this.loadingText = 'Loading...';
        this.role = 'alert';
        this.ariaLive = 'assertive';
        this.tabindex = -1;
    }
}
AwSpinnerComponent.ɵfac = function AwSpinnerComponent_Factory(t) { return ɵAwSpinnerComponent_BaseFactory(t || AwSpinnerComponent); };
AwSpinnerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AwSpinnerComponent, selectors: [["aw-spinner"]], inputs: { spinnerSize: "spinnerSize", loadingText: "loadingText", role: ["data-role", "role"], ariaLive: ["data-aria-live", "ariaLive"], tabindex: ["data-tabindex", "tabindex"], spinnerColor: "spinnerColor", elementId: "elementId", styleClasses: "styleClasses" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 10, vars: 13, consts: [[3, "ngClass"], [1, "visuallyhidden"], [1, "circle-clipper", "left"], [1, "circle"], [1, "gap-patch"], [1, "circle-clipper", "right"]], template: function AwSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "p", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelement(5, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelement(7, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵelement(9, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("preloader-wrapper active ", ctx.spinnerSize, "");
        ɵngcc0.ɵɵproperty("ngClass", ctx.styleClasses);
        ɵngcc0.ɵɵattribute("role", ctx.role)("aria-live", ctx.ariaLive)("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.loadingText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("spinner-layer ", ctx.spinnerColor, "");
        ɵngcc0.ɵɵattribute("id", ctx.elementId)("automation", ctx.automationValue || "spinnerComponent");
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
AwSpinnerComponent.selectorDowngrade = 'aw-spinner';
AwSpinnerComponent.propDecorators = {
    spinnerColor: [{ type: Input }],
    spinnerSize: [{ type: Input }],
    elementId: [{ type: Input }],
    loadingText: [{ type: Input }],
    role: [{ type: Input, args: ['data-role',] }],
    ariaLive: [{ type: Input, args: ['data-aria-live',] }],
    tabindex: [{ type: Input, args: ['data-tabindex',] }],
    styleClasses: [{ type: Input }]
};
const ɵAwSpinnerComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(AwSpinnerComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'aw-spinner',
                template: "<div class=\"preloader-wrapper active {{spinnerSize}}\" \n    [attr.role]=\"role\"\n    [ngClass]=\"styleClasses\"\n    [attr.aria-live]=\"ariaLive\"\n    [attr.tabindex]=\"tabindex\"\n>\n    <p class=\"visuallyhidden\">{{loadingText}}</p>\n    <div class=\"spinner-layer {{spinnerColor}}\"\n         [attr.id]=\"elementId\"\n         [attr.automation]=\"automationValue || 'spinnerComponent'\">\n        <div class=\"circle-clipper left\">\n            <div class=\"circle\"></div>\n        </div>\n        <div class=\"gap-patch\">\n            <div class=\"circle\"></div>\n        </div>\n        <div class=\"circle-clipper right\">\n            <div class=\"circle\"></div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], null, { spinnerSize: [{
            type: Input
        }], loadingText: [{
            type: Input
        }], role: [{
            type: Input,
            args: ['data-role']
        }], ariaLive: [{
            type: Input,
            args: ['data-aria-live']
        }], tabindex: [{
            type: Input,
            args: ['data-tabindex']
        }], spinnerColor: [{
            type: Input
        }], elementId: [{
            type: Input
        }], styleClasses: [{
            type: Input
        }] }); })();
if (false) {
    AwSpinnerComponent.selectorDowngrade;
    AwSpinnerComponent.prototype.spinnerColor;
    AwSpinnerComponent.prototype.spinnerSize;
    AwSpinnerComponent.prototype.elementId;
    AwSpinnerComponent.prototype.loadingText;
    AwSpinnerComponent.prototype.role;
    AwSpinnerComponent.prototype.ariaLive;
    AwSpinnerComponent.prototype.tabindex;
    AwSpinnerComponent.prototype.styleClasses;
}

class AwSpinnerModule {
}
AwSpinnerModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AwSpinnerModule });
AwSpinnerModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AwSpinnerModule_Factory(t) { return new (t || AwSpinnerModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AwSpinnerModule, { declarations: function () { return [AwSpinnerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AwSpinnerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AwSpinnerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AwSpinnerComponent
                ],
                exports: [
                    AwSpinnerComponent
                ]
            }]
    }], null, null); })();

export { AwSpinnerComponent, AwSpinnerModule };

//# sourceMappingURL=aw-hospital-aw-components-lib-aw-spinner.js.map